/*
 * Recherche interne à la catégorie (09/09).
 *
 * On tape « togo » sur la page Trottinettes : seules les trottinettes Togo
 * s'affichent. Aucune pièce détachée, aucun accessoire — c'est tout l'intérêt
 * par rapport à la recherche du header, qui elle balaie le catalogue entier.
 *
 * L'index de la collection (templates/collection.searchindex.liquid) est
 * chargé à la première frappe, pas au chargement de la page : tant que
 * personne ne cherche, ça ne coûte rien. Il est ensuite gardé en cache de
 * session, donc une seule fois par catégorie et par visite.
 *
 * La grille d'origine n'est jamais détruite, juste masquée : champ vidé, elle
 * revient telle quelle avec sa pagination.
 */
(function () {
  var root = document.querySelector('[data-collection-search]');
  var grid = document.getElementById('CollectionGrid');
  if (!root || !grid) return;

  var input = root.querySelector('[data-cs-input]');
  var clearBtn = root.querySelector('[data-cs-clear]');
  var statusEl = root.querySelector('[data-cs-status]');
  if (!input) return;

  var indexUrl = root.getAttribute('data-index-url');
  var originals = grid.querySelectorAll('.product-grid, .pagination, .collection__empty');

  var results = document.createElement('div');
  results.className = 'product-grid';
  results.setAttribute('data-cs-results', '');
  results.hidden = true;
  grid.appendChild(results);

  var emptyEl = document.createElement('p');
  emptyEl.className = 'collection__empty collection-search__empty';
  emptyEl.setAttribute('data-cs-empty', '');
  emptyEl.hidden = true;
  grid.appendChild(emptyEl);

  // ---------- Normalisation ----------
  // Accents et ponctuation dégagés des deux côtés : « télé-commande » se
  // trouve en tapant « telecommande », et « Togo » en tapant « togo ».
  function norm(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function esc(str) {
    return (str || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ---------- Chargement de l'index ----------
  var indexPromise = null;

  function pageUrl(page) {
    return indexUrl + (indexUrl.indexOf('?') > -1 ? '&' : '?') + 'page=' + page;
  }

  // Surtout PAS d'en-tête Accept: application/json ici. Shopify intercepte la
  // requête et renvoie SA représentation JSON de la collection à la place de
  // notre gabarit : on récupère alors un objet sans "items", et la recherche
  // ne trouve jamais rien. Sans cet en-tête, le gabarit searchindex répond
  // normalement.
  function fetchPage(page) {
    return fetch(pageUrl(page))
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
  }

  // Le numéro dans la clé invalide les index mis en cache par une version
  // précédente du script (v4 : ajout du drapeau précommande ; v5 : ajout du
  // drapeau « Top des ventes »).
  function cacheKey() { return 'um_cs5_' + indexUrl; }

  // Durée de vie du cache. L'index embarque des états qui bougent (prix,
  // disponibilité, pastilles précommande et Top des ventes mises à jour par la
  // veille) : un onglet laissé ouvert plusieurs heures afficherait sinon une
  // pastille que le catalogue n'a plus. Passé ce délai on redemande l'index au
  // serveur.
  var CACHE_TTL = 30 * 60 * 1000;

  function loadIndex() {
    if (indexPromise) return indexPromise;

    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey()) || 'null');
      if (cached && cached.items && (Date.now() - cached.ts) < CACHE_TTL) {
        indexPromise = Promise.resolve(cached.items);
        return indexPromise;
      }
    } catch (e) { /* mode privé, quota… on recharge, c'est tout */ }

    root.classList.add('collection-search--busy');

    indexPromise = fetchPage(1)
      .then(function (first) {
        var pages = first.pages || 1;
        var items = first.items || [];
        if (pages <= 1) return items;
        // Pages suivantes en parallèle : Shopify plafonne la pagination à 50
        // produits, une grosse catégorie ferait sinon attendre en série.
        var rest = [];
        for (var p = 2; p <= pages; p++) rest.push(fetchPage(p));
        return Promise.all(rest).then(function (list) {
          list.forEach(function (data) {
            items = items.concat((data && data.items) || []);
          });
          return items;
        });
      })
      .then(function (items) {
        items.forEach(function (it) {
          it._n = norm(it.t + ' ' + (it.k || ''));
          it._t = norm(it.t);
        });
        try { sessionStorage.setItem(cacheKey(), JSON.stringify({ ts: Date.now(), items: items })); } catch (e) {}
        root.classList.remove('collection-search--busy');
        return items;
      })
      .catch(function () {
        root.classList.remove('collection-search--busy');
        indexPromise = null;
        return null;
      });

    return indexPromise;
  }

  // ---------- Recherche ----------
  // Tous les mots tapés doivent être présents (« togo 2 » ne sort que les Togo
  // qui portent aussi un 2). Un titre qui commence par le terme remonte en
  // tête, puis les titres qui le contiennent, puis les correspondances sur la
  // référence, la marque ou les tags.
  function search(items, query) {
    var tokens = norm(query).split(' ').filter(Boolean);
    if (!tokens.length) return [];

    var out = [];
    items.forEach(function (it) {
      var hay = it._n || norm(it.t + ' ' + (it.k || ''));
      var title = it._t || norm(it.t);
      for (var i = 0; i < tokens.length; i++) {
        if (hay.indexOf(tokens[i]) === -1) return;
      }
      var score = 3;
      if (title.indexOf(tokens[0]) === 0) score = 0;
      else if (title.indexOf(' ' + tokens[0]) > -1) score = 1;
      else if (title.indexOf(tokens[0]) > -1) score = 2;
      out.push({ item: it, score: score });
    });

    out.sort(function (a, b) {
      if (a.score !== b.score) return a.score - b.score;
      return a.item.t.localeCompare(b.item.t, 'fr');
    });

    return out.map(function (r) { return r.item; });
  }

  // ---------- Rendu ----------
  // Même balisage que snippets/product-card.liquid : les steppers de quantité
  // du thème sont branchés en délégation sur document, ils fonctionnent donc
  // aussi sur les cartes injectées ici.
  function cardHtml(it) {
    var badge = '';
    if (it.c) {
      var universal = it.c === 'Universel';
      var label = universal ? 'Universel' : 'Selon modèle';
      badge = '<span class="product-card__fit ' + (universal ? 'product-card__fit--universal' : '') +
        '" data-compat-badge data-compat-tags="' + esc(it.c) + '" data-default-text="' + label + '">' + label + '</span>';
    }

    // Pastille « Précommande » : le drapeau vient de l'index (donc du métachamp
    // custom.statut_precommande côté Liquid), le JS ne fait que poser le même
    // balisage que snippets/product-card.
    var preorder = it.pc
      ? '<span class="product-card__preorder' + (it.c ? ' product-card__preorder--stacked' : '') + '">Précommande</span>'
      : '';
    // Pastille « Top des ventes » : même principe, drapeau "tv" de l'index
    // (métachamp custom.top_vente) et balisage identique à
    // snippets/top-vente-badge. Posée en bas à gauche par le CSS, elle n'a pas
    // de variante décalée : aucun conflit possible avec les pastilles du haut.
    var topseller = it.tv ? '<span class="product-card__topseller">Top des ventes</span>' : '';
    var discount = it.d > 0 ? '<span class="product-card__discount">−' + it.d + ' %</span>' : '';
    var image = it.i ? '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" loading="lazy">' : '';
    // La ligne de disponibilité arrive déjà rendue par snippets/stock-line via
    // l'index : précommande, stock ou sur commande, c'est la même règle que sur
    // les cartes servies par Liquid. Le repli ne sert qu'à un index d'ancienne
    // version resté en cache de session.
    var stock = it.s || (it.a
      ? '<div class="product-card__stock"><span class="product-card__stock-dot"></span>En stock — expédié aujourd’hui</div>'
      : '<div class="product-card__stock"><span class="product-card__stock-dot product-card__stock-dot--low"></span>Sur commande</div>');

    return '' +
      '<div class="product-card" data-available="' + (it.a ? 'true' : 'false') + '">' +
        '<a href="' + esc(it.u) + '" class="product-card__media">' + image + badge + preorder + discount + topseller + '</a>' +
        '<div class="product-card__body">' +
          '<div class="mono-label product-card__meta">' + esc(it.m) + '</div>' +
          '<a href="' + esc(it.u) + '"><h3>' + esc(it.t) + '</h3></a>' +
          stock +
          it.p +
          '<div class="product-card__qty" data-quick-add-wrap data-variant-id="' + it.v + '">' +
            '<button type="button" class="qty-btn qty-btn--minus" data-qty-minus aria-label="Retirer un exemplaire">−</button>' +
            '<input type="number" class="qty-input" data-qty-input value="0" data-previous="0" min="0" inputmode="numeric" aria-label="Quantité à ajouter">' +
            '<button type="button" class="qty-btn qty-btn--plus" data-qty-plus aria-label="Ajouter au panier">+</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function showOriginal() {
    Array.prototype.forEach.call(originals, function (el) { el.hidden = false; });
    results.hidden = true;
    results.innerHTML = '';
    emptyEl.hidden = true;
    if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
  }

  function showResults(list, query) {
    Array.prototype.forEach.call(originals, function (el) { el.hidden = true; });

    if (!list.length) {
      results.hidden = true;
      results.innerHTML = '';
      emptyEl.hidden = false;
      emptyEl.innerHTML = 'Aucun résultat pour « ' + esc(query) + ' » dans cette catégorie. ' +
        '<a href="/search?q=' + encodeURIComponent(query) + '&amp;type=product">Chercher dans tout le catalogue</a>' +
        ' ou appelez l’atelier, on vous trouve la référence.';
      if (statusEl) { statusEl.hidden = true; }
      return;
    }

    emptyEl.hidden = true;
    var html = '';
    for (var i = 0; i < list.length; i++) html += cardHtml(list[i]);
    results.innerHTML = html;
    results.hidden = false;

    if (statusEl) {
      statusEl.textContent = list.length + (list.length > 1 ? ' résultats' : ' résultat') +
        ' pour « ' + query + ' » dans cette catégorie';
      statusEl.hidden = false;
    }

    // Les champs quantité repartent à 0 : on les réaligne sur le panier réel.
    if (window.umRefreshCart) window.umRefreshCart();
  }

  // ---------- Événements ----------
  var timer = null;
  var lastQuery = '';

  function run() {
    var query = input.value.trim();
    if (clearBtn) clearBtn.hidden = query === '';
    if (query === lastQuery) return;
    lastQuery = query;

    if (query.length < 2) {
      showOriginal();
      return;
    }

    loadIndex().then(function (items) {
      // Une frappe plus récente est déjà passée : on laisse la main.
      if (input.value.trim() !== query) return;
      if (!items) {
        if (statusEl) {
          statusEl.textContent = 'Recherche indisponible pour le moment.';
          statusEl.hidden = false;
        }
        return;
      }
      showResults(search(items, query), query);
    });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(run, 130);
  });

  // Précharge dès le focus : l'index est prêt avant la fin du premier mot.
  input.addEventListener('focus', function () { loadIndex(); }, { once: true });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(timer);
      run();
      input.blur();
    }
    if (e.key === 'Escape' && input.value) {
      e.preventDefault();
      input.value = '';
      run();
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      run();
    });
  }
})();
